<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M2.5 12C2.5 12 5.5 6.5 12 6.5C18.5 6.5 21.5 12 21.5 12C21.5 12 18.5 17.5 12 17.5C5.5 17.5 2.5 12 2.5 12Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <circle cx="12" cy="12" r="2.75" stroke="currentColor" stroke-width="1.75" />
</svg>
